// 方便书写和检测
// export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_CODE_TIMER = 'SET_CODE_TIMER'


